export const defaultDateFormat = 'DD.MM.YYYY';
export const defaultGtmFormat = 'YYYY-MM-DD';
export const defaultDateTimeFormat = 'DD.MM.YYYY HH:mm:ss';
